var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHeartStraight = function SvgIconHeartStraight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.699 3.165a5.875 5.875 0 0 1 6.548 1.54c2.164 2.406 1.777 6.074-.41 8.272l-.002.002-7.594 7.594-.707-.707.704.71a1.76 1.76 0 0 1-2.476 0l-.004-.003-7.79-7.79a5.876 5.876 0 0 1 .236-8.53c2.407-2.164 6.075-1.777 8.273.41l.004.005.519.522.715-.72.003-.002a5.9 5.9 0 0 1 1.98-1.303m-2.7 15.82 7.42-7.418v-.001c1.544-1.552 1.7-4.014.34-5.525l-.001-.002a3.875 3.875 0 0 0-5.625-.158l-.001.001-1.423 1.432a1 1 0 0 1-1.42 0l-1.225-1.235C8.513 4.537 6.051 4.38 4.54 5.74l-.002.002a3.875 3.875 0 0 0-.156 5.626z",
    clipRule: "evenodd"
  })));
};
export default SvgIconHeartStraight;